<template>
  <div class="page-index welcome">
    <h3>欢迎登陆 管理后台！</h3>
    <div class="flex">
      <div class="record-box">
        <div>
          <p>累计登录次数：{{userInfo.userLoginLog.times}}</p>
          <p>上次登陆IP：{{userInfo.userLoginLog.loginIp}}</p>
          <p>上次登陆时间：{{userInfo.userLoginLog.loginTime}}</p>
          <p>当前浏览器：{{clientName}} {{clientVersion}}</p>
          <p>打印控件：jcp {{jatoolsVersion}}</p>
          <p><b>第一次使用该系统请先预览</b><a href="/tms-resources/使用说明.pdf" target="_blank">使用说明</a></p>
          <p><a href="/tms-resources/setup.exe">打印控件下载</a>如需打印标签编辑/打印功能。请下载打印控件</p>
          <p><a href="/tms-resources/jcp.zip">优化插件下载</a>/<a href="jatools://ans">插件设置</a></p>
          <p>chrome浏览器下载<a href="/tms-resources/chrome.exe">64位下载</a>/<a href="/tms-resources/chrome32.exe">32位下载</a>请使用统一的浏览器，以免出现打印问题</p>
        </div>
      </div>
      <div class="video-box">
        <div>
          <p>标签编辑视频</p>
          <video src="/tag.mp4" controls="controls"></video>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import { mapGetters } from 'vuex'
  import browser from '../utils/browser'
  import { getJCP } from '../../public/jcp'
  import DDDY from '../../public/dddy'

  export default {
    name: 'index',
    data() {
      return {
        clientName: browser.client.name,
        clientVersion: browser.client.version,
        jatoolsVersion: '未启动/未安装'
      }
    },
    computed: {
      ...mapGetters([
        'userInfo'
      ])
    },
    created() {
      this.getVer()
      if (this.clientName !== 'Google Chrome') {
        this.$message({
          type: 'warning',
          duration: 6000,
          message: `当前浏览器：${this.clientName},建议您使用chrome浏览器`
        })
      }
    },
    activated() {
      this.getVer()
    },
    methods: {
      getVer() {
        getJCP().getVersion(version => {
          this.jatoolsVersion = version
          console.log('当前版本号：' + version)
        })
      }
    }
  }
</script>

<style lang="stylus">
  @import "~assets/stylus/common.styl";

  .page-index
  &.welcome
    h3
      color #000
      font-weight bold
    p
      margin 5px 0
    video
      width 100%
    .flex
      .record-box
        width 30%
        height 100%
        margin-right 30px
        background-color #fff
        div
          padding 30px
      .video-box
        flex: 1
        width calc(100% - 30% - 30px)
        background-color #fff
        div
          padding 30px
</style>
